import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { UserGradeSummaryResponseType } from '../types';

export const UserGradeSummaryRepository = {
  getUserGradeSummary: (userId: number): Promise<UserGradeSummaryResponseType> =>
    AccountUserApiV2.getAccountUserDetailGradeSummary(userId),
};
